<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(tipologia)="row">
                        {{ row.item.tipologia == null ? "TUTTE" : row.item.tipologia }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Modalita Somministrazione" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Modalita Somministrazione" @click="onDelete(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-configurazione-modalita-somministrazione-modal-edit-component ref="modalModalitaSomministrazione" @afterSave="onAfterSaveModal" />
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneModalitaSomministrazioneModalEditComponent from "./RsaConfigurazioneModalitaSomminsitrazioneModalEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaConfigurazioneModalitaSomministrazioneModalEditComponent },
    data() {
        return {
            filtroModalitaSomministrazione: {},
            pathResource: "/rsapazienteprescrizionimodalitasomministrazione",
            showModalLoading: false,
            show: true,
            perPage: 50,
            currentPage: 1,
            allItems: [],
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Nome", key: "nome", sortable: true },
                { label: "Descrizione", key: "descrizione", sortable: true },
                { label: "Tipologia", key: "tipologia", sortable: true },
                { label: "Ordering", key: "ordering", sortable: true },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroModalitaSomministrazione = sessionStorage.getItem("filtroModalitaSomministrazione");
            if (filtroModalitaSomministrazione) {
                me.filtroModalitaSomministrazione = JSON.parse(filtroModalitaSomministrazione);
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroModalitaSomministrazione, me.loadDataModalitaSomministrazioneSuccess, me.loadDataModalitaSomministrazioneError);
        },
        loadDataModalitaSomministrazioneSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataModalitaSomministrazioneError(error) {
            let me = this;
            console.log("Errore nel caricamento dei device:", error);
            me.$emit("afterLoadData");
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroModalitaSomministrazione = sessionStorage.getItem("filtroModalitaSomministrazione");
            if (filtroModalitaSomministrazione) {
                me.filtroModalitaSomministrazione = JSON.parse(filtroModalitaSomministrazione);
            }
            me.loadData(me.filtroModalitaSomministrazione);
        },
        onEdit(item) {
            this.$refs.modalModalitaSomministrazione.show(item);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare questa modalità di somministrazione: " + item.nome, {
                    title: "Conferma eliminazione",
                    size: "sm",
                    okVariant: "danger",
                    okTitle: "Elimina",
                    cancelTitle: "Annulla",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteModalitaSomministrazione(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteModalitaSomministrazione(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.deleteModalitaSomministrazioneSuccess, me.deleteModalitaSomministrazioneError);
        },
        deleteModalitaSomministrazioneSuccess() {
            let me = this;
            me.$bvModal.msgBoxOk("Voce menu eliminata con successo.", {
                title: "Eliminazione completata",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            me.loadData();
        },
        deleteModalitaSomministrazioneError() {
            let me = this;
            me.$bvModal.msgBoxOk("Errore durante l'eliminazione della modalità di somministrazione.", {
                title: "Errore",
                size: "sm",
                okVariant: "danger",
                centered: true,
            });
        },
        onAfterSaveModal() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
